import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="font-heading text-xl font-bold whitespace-nowrap">
                91叔叔
              </Link>
              <p className="mt-3 text-sm text-background-50/70 leading-relaxed">
                深受用户喜爱的内容平台，为您提供优质文章、实用资源和精彩内容。
              </p>
            </div>

            <div>
              <h4 className="font-medium text-sm mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">首页</Link>
                <Link to="/category/guide" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">使用指南</Link>
                <Link to="/category/resource" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">资源推荐</Link>
                <Link to="/category/member" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">会员专区</Link>
              </div>
            </div>

            <div>
              <h4 className="font-medium text-sm mb-4">关于我们</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/about" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">品牌介绍</Link>
                <Link to="/about#reputation" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">用户口碑</Link>
                <Link to="/about#contact" className="text-sm text-background-50/70 hover:text-background-50 transition-colors">联系我们</Link>
              </div>
            </div>

            <div>
              <h4 className="font-medium text-sm mb-4">联系方式</h4>
              <div className="flex flex-col gap-2.5 text-sm text-background-50/70">
                <span>邮箱：contact@91uncle.com</span>
                <span>客服热线：400-888-9191</span>
                <span>工作时间：周一至周日 9:00-21:00</span>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/50">
              &copy; {currentYear} 91叔叔. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-xs text-background-50/50">
              <a href="#" className="hover:text-background-50/80 transition-colors">隐私政策</a>
              <a href="#" className="hover:text-background-50/80 transition-colors">服务条款</a>
              <a href="#" className="hover:text-background-50/80 transition-colors">Cookie政策</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}